// extracted by mini-css-extract-plugin
export var searchHeader = "_6g-0";
export var searchHeaderDark = "_6g-1";